import styled from 'styled-components';
import { ReactComponent as Notification } from '~/assets/images/notification-icon.svg';

const ChallengesContainer = styled.div`
  height: 100%;
  width: 100%;
  background-color: #ffffff;
`;

ChallengesContainer.Container = styled.div`
  width: 100%;
  background-color: #ffffff;
  @media (max-width: 770px) {
    height: 100%;
    overflow-y: hidden;
    padding: 0;
  }
`;

ChallengesContainer.Content = styled.div`
  width: 100%;
  height: 100vh;
  background-color: #ffffff;
  @media (max-width: 770px) {
    width: 100%;
  }
`;

ChallengesContainer.NavigationContainer = styled.div`
  width: 100%;
  height: 87vh;
  padding: 0px 65px;
  overflow-y: scroll;

  @media (max-width: 1400px) {
    height: 80vh;
  }

  @media (max-width: 770px) {
    width: 100%;
    height: calc(100% - 185px);
    padding: 0px 5px 30px 5px;
    background-color: #ffffff;
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
    gap: 1rem;
  }

  @media (min-width: 770px) and (max-width: 1400px) {
    padding: 0px 65px 15px 65px;
  }
`;

ChallengesContainer.Top = styled.div`
  width: 100%;
  * {
    margin: 0;
  }
`;

ChallengesContainer.TitleHeader = styled.div`
  display: flex;
  justify-content: center;
  margin-top: -8%;

  @media (max-width: 770px) {
    margin-top: -20%;
  }

  img {
    width: 40%;
    height: 40%;

    @media (max-width: 770px) {
      width: 20%;
      height: 20%;
    }

  }
`;

ChallengesContainer.DiamondIcon = styled(Notification)`
  margin-left: -10px;
  width: 40px;
  float: left;
  margin-right: 10px;
`;

ChallengesContainer.ChallengeCards = styled.div`
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #80808066;
  border: 0.5px solid #dfdfdf;
  border-radius: 16px;
  padding: 5px 0rem 5px 1.5rem;
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 13px 0px 13px 19px;

  @media (max-width: 770px) {
    display: none;
  }
`;

ChallengesContainer.ChallengeCardsMobile = styled.div`
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #80808066;
  border: 0.5px solid #dfdfdf;
  border-radius: 16px;
  padding: 5px 0rem 5px 1.5rem;
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media (min-width: 770px) {
    display: none;
  }
`;

ChallengesContainer.ImgDetails = styled.img`
  margin: 0 0 0.15rem 0.4rem;

  @media (max-width: 500px) {
    margin: 0px 0.1rem 0.1rem 0.2rem;
  }
`;

ChallengesContainer.Details = styled.div`
  background-color: #000FFF;
  position: relative;
  color: white;
  padding: 0.15rem 1rem;
  border-bottom-left-radius: 0.8rem;
  border-top-left-radius: 0.8rem;
  height: 1.3rem;
  width: 96px;
  cursor: pointer;

  @media (max-width: 500px) {
    padding: 0.2rem 0 0.2rem 0.4rem;
  }

  @media (min-width: 768px) {
    font-size: 0.6rem !important;
    padding: 0.15rem 0.2rem;
    ${ChallengesContainer.ImgDetails} {
      width: 18%;
    }
  }

  @media (min-width: 800px) {
    font-size: 0.6rem;
    padding: 0.15rem 0.4rem;
    ${ChallengesContainer.ImgDetails} {
      width: 18%;
    }
  }

  @media (min-width: 850px) {
    font-size: 0.7rem !important;
    padding: 0.15rem 0.5rem;
    ${ChallengesContainer.ImgDetails} {
      width: 18%;
    }
  }

  @media (min-width: 900px) {
    font-size: 0.7rem !important;
    padding: 0.15rem 0.5rem;
    ${ChallengesContainer.ImgDetails} {
      width: 18%;
    }
  }

  @media (max-width: 992px) {
    width: 113px;
    font-size: 13px;
    padding: 0 18px !important;
    height: auto;
  }
`;

ChallengesContainer.Points = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  .title-challenge {
    margin-bottom: 0px;
    color: #000FFF;
  }
  .title-points {
    margin-bottom: 0px;
    color: rgba(0, 0, 0, 0.3);
  }
  .first {
    display: flex;
    align-items: center;
  }
  .second {
    display: flex;
    align-items: center;
    gap: 30px;
  }
  .name {
    color: rgba(0, 0, 0, 0.6);
    font-size: 12px;
    display: flex;
    align-items: center;
    max-width: 20%;

    @media (max-width: 770px) {
      max-width: 50%;
    }
  }
  .criterion {
    color: rgba(0, 0, 0, 0.6);
    font-size: 12px;
    display: flex;
    align-items: center;
  }

  .buble {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: ${props => props.evidence === 'Realizado' && '#3CBC9C'};
    background: ${props => props.evidence === 'Não Realizado' && '#A440E3'};
    background: ${props => props.evidence === 'Aprovado' && '#000FFF'};
    background: ${props => props.evidence === 'Reprovado' && '#F16B61'};
    background: ${props => props.evidence === 'Futuro' && '#F2D155'};
    float: left;
    margin-right: 10px;
  }
  .border-list {
    border-left: 1px solid rgba(0, 0, 0, 0.2);
    width: 1px;
    height: 55px;
  }
  .evidence {
    color: rgba(0, 0, 0, 0.3);
    font-size: 12px;
    cursor: pointer;
    opacity: ${props => props.evidence === 'Realizado' && '0.4'};
    opacity: ${props => props.evidence === 'Não Realizado' && '0.4'};
    opacity: ${props => props.evidence === 'Aprovado' && '0.4'};
    opacity: ${props => props.evidence === 'Reprovado' && '0.4'};
    opacity: ${props => props.evidence === 'Futuro' && '0.4'};
    opacity: ${props => props.evidence === 'Pendente' && '1'};
    img {
      width: 12px;
      margin-top: -3px;
      margin-right: 4px;
      opacity: 0.6;
    }
  }

  @media (max-width: 770px) {
    .title-challenge {
      line-height: 1.1;
    }
  }
`;


ChallengesContainer.MobileChallengeCards = styled.div`
  display: none;
  @media (max-width: 992px) {
    display: block;
  }
`;

ChallengesContainer.MobileCard = styled.div`
  box-shadow: 0px 3px 6px #80808066;
  border-radius: 16px;
  border: 0.5px solid #dfdfdf;
  margin-top: 20px;
  padding-bottom: 20px;
`;

ChallengesContainer.CardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid rgba(0, 0, 0, 0.2);
  padding: 15px 24px;
  padding-right: 0px;
  margin-bottom: 25px;
  align-items: center;
  color: #333;
  .capitalize {
    text-transform: capitalize;
    text-transform: capitalize;
    color: #333;
    font-size: 14px;
    margin-right: 20px;
  }
`;

ChallengesContainer.InfoMobileDetails = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  line-height: 1.4;
  color: #555;
  margin-top: 14px;
  a {
    color: #000FFF !important;
    font-weight: bold;
  }
`;

ChallengesContainer.SubmitEvidences = styled.div`
  color: #fff;
  background: ${(props) => props.finished ? "#707070" : "#000FFF" };
  /* background: #000FFF; */
  box-shadow: 0px 3px 6px #80808066;
  text-align: center;
  padding: 5px;
  margin-top: 15px;
  border-radius: 5px;
  /* opacity: ${props => (props.evidence ? '1' : '0.4')}; */
`;

ChallengesContainer.SectionChallenges = styled.div`

  @media(max-width: 770px) {
    margin: 0 1rem;
  }

  .subhead {
    opacity: 0.7;
    h3 {
      font-size: 22px;
      margin-bottom: 0px;
      margin-top: 3px;
    }
    .challengeTitle {
      display: block;
    }
  }
`;


ChallengesContainer.PageTitleContainerFilter = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  @media (max-width: 1080px) {
    flex-wrap: wrap;
  }

  /* @media (min-width: 770px) and (max-width: 1100px) {
    width: 35%;
  } */

  @media (min-width: 350px) and (max-width: 550px) {
    width: 80% !important;
  }

  @media (max-width: 340px) {
    width: 90% !important;
    margin: 0 1rem 0 0;
  }
`;

ChallengesContainer.DivisionFilters = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
`;

ChallengesContainer. Middle = styled.div`
  color: #000fff;
  font-size: 14px;
  align-items: center;
  flex-direction: row;
  @media (max-width: 1000px) {
    margin: 20px 0px;
  }
  @media (max-width: 770px) {
    display: none;
  }
`;

ChallengesContainer.StatusIcon = styled.img`
  width: 1rem;
  height: 1rem;
  margin-right: 4px;

  @media (max-width: 770px) {
    width: 0.85rem;
    height: 0.85rem;
  }
`;

ChallengesContainer.PeriodSize = styled.div`
  font-size: 1rem;
  color: #000fff;
  display: inline-block;

  @media (max-width: 770px) {
    font-size: 0.85rem;
  }
`;

ChallengesContainer.FilterButtonWhite = styled.div`
  display: inline-flex;
  color: #b2b2b2;
  background-color: #fff;
  border: 1px solid #b2b2b2;
  border-radius: 13px;
  padding: 3px 14px;
  font-size: 14px;
  margin: 0px 5px;
  justify-content: center;
  align-items: center;
  &:hover {
    cursor: pointer;
  }
  @media (max-width: 455px) {
    margin-top: 10px;
  }
`;

ChallengesContainer.FilterButton = styled.div`
  display: inline-flex;
  color: #fff;
  background-color: #000fff;
  border-radius: 13px;
  padding: 3px 14px;
  font-size: 14px;
  margin: 0px 5px;
  justify-content: center;
  align-items: center;
  &:hover {
    cursor: pointer;
  }

  @media (max-width: 425px) {
    margin: ${props => (props.margin ? props.margin : '5px 5px')};
  }
`;

ChallengesContainer.Right = styled.div`
  color: #000fff;
  font-size: 14px;
  display: flex;
  align-items: center;
  flex-direction: row;
  @media (max-width: 770px) {
    display: none;
  }
`;

ChallengesContainer.Middle = styled.div`
  color: #000fff;
  font-size: 14px;
  align-items: center;
  flex-direction: row;
  @media (max-width: 1000px) {
    margin: 20px 0px;
  }
  @media (max-width: 770px) {
    display: none;
  }
`;

ChallengesContainer.StatusIcon = styled.img`
  width: 1rem;
  height: 1rem;
  margin-right: 4px;

  @media (max-width: 770px) {
    width: 0.85rem;
    height: 0.85rem;
  }
`;

ChallengesContainer.PeriodSize = styled.div`
  font-size: 1rem;
  color: #000fff;
  display: inline-block;

  @media (max-width: 770px) {
    font-size: 0.85rem;
  }
`;

ChallengesContainer.FilterButtonWhite = styled.div`
  display: inline-flex;
  color: #b2b2b2;
  background-color: #fff;
  border: 1px solid #b2b2b2;
  border-radius: 13px;
  padding: 3px 14px;
  font-size: 14px;
  margin: 0px 5px;
  justify-content: center;
  align-items: center;
  &:hover {
    cursor: pointer;
  }
  @media (max-width: 455px) {
    margin-top: 10px;
  }
`;

ChallengesContainer.RightCode = styled.div`
  width: 30%;
  margin: 1px;
  display: flex;
  align-items: center;
  flex-direction: row;
  font-size: 14px;

  // @media(max-width: 1700px) {
  //   width: 40%;
  // }

  // @media(max-width: 1450px) {
  //   width: 34%;
  // }

  // @media(max-width: 1340px) {
  //   width: 30%;
  // }

  // @media(max-width: 1265px) {
  //   width: 25%;
  // }

  // @media(max-width: 1200px) {
  //   width: 14%;
  // }

  // @media(max-width: 1150px) {
  //   width: 30%;
  // }

  @media (max-width: 770px) {
    display: none;
  }
`;

ChallengesContainer.DivisionChangeCode = styled.div`
  width: 100%;
  margin-left: 5px;
  @media (max-width: 769px) {
    margin-left: 5px;
    width: 50%;
    margin: 0rem;
    background-color: white;
  }

  @media (max-width: 550) {
    width: 60%;
  }

  @media (max-width: 480) {
    width: 80%;
  }

  input {
    box-shadow: 0px 2px 4px #00000066;
    border-radius: 0.4rem;
    border: 0;
    padding: 0.2rem;
  }
`;

ChallengesContainer.InsertCode = styled.div`
  display: flex;
  flex-direction: column;

  input {
    border: 1px solid #b0b0b0;
    @media(max-width: 770px) {
      margin-left: 5px;
      font-size: .85rem;
    }
  }
`;

ChallengesContainer.DivisionChangeCode = styled.div`
  width: 100%;
  margin-left: 5px;
  @media (max-width: 769px) {
    margin-left: 5px;
    width: 50%;
    margin: 0rem;
    background-color: white;
  }

  @media (max-width: 550) {
    width: 60%;
  }

  @media (max-width: 480) {
    width: 80%;
  }

  input {
    box-shadow: 0px 2px 4px #00000066;
    border-radius: 0.4rem;
    border: 0;
    padding: 0.2rem;
  }
`;

ChallengesContainer.FilterMobile = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  width: 100%;
  @media (min-width: 770px) {
    display: none;
  }
`;

ChallengesContainer.First = styled.div`
  margin: 14px 32px 0px 32px;

  @media (max-width: 770px) {
    margin: 14px 0px 0px 0px;
  }
`;

ChallengesContainer.Second = styled.div`
  margin: 14px 32px 0px 32px;

  @media (max-width: 770px) {
    margin: 14px 0px 0px 0px;
  }
`;

ChallengesContainer.BoxStatus = styled.div`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  margin-right: 10px;
  font-size: 1rem;
  margin-bottom: -20px;
  span {
    color: #000fff;
  }

  @media (max-width: 770px) {
    font-size: 0.85rem;
  }
`;

ChallengesContainer.Close = styled.div`
  display: inline-flex;
  color: #000fff;
  background: #fff;
  width: 13px;
  height: 13px;
  border-radius: 20px;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  text-align: center;
  margin-left: 5px;
`;

ChallengesContainer.CodeMobile = styled.div`
  margin: 14px 0px 0px 0px;
  display: flex;
  align-items: center;
  flex-direction: row;
  font-size: 14px;
`;

ChallengesContainer.AreaTop = styled.div`
  padding: 2px;
  display: flex;
  flex-direction: row;
  heigth: 60%;
  justify-content: space-between;

  @media (max-width: 770px) {
    flex-direction: column;
  }
`

ChallengesContainer.AreaRanking = styled.div`
  padding: 2px;
  width: 100%;
  heigth: 60%;
  display: flex;
  flex-direction: row;

  @media (max-width: 770px) {
    width: 100%;
  }

  @media (max-width: 1000px) {
    flex-direction: column;
  }
`

ChallengesContainer.AreaLogoLapidarMobile = styled.div`
  padding: 2px;
  width: 100%;

  img {
    width: 40%;
    margin-top: 100px;
  }

  @media (min-width: 770px) {
    margin-top: 200px;
    display: none;
  }
`

ChallengesContainer.AreaLogoLapidar = styled.div`
  padding: 2px;
  width: 50%;

  @media (max-width: 770px) {
    display: none;
  }
`

ChallengesContainer.AreaSaldo = styled.div`
  display: flex;
  flex-direction: row;
`;

ChallengesContainer.AreaImageInfo = styled.div`
  min-width: 35px;
`;

ChallengesContainer.ImageInfo = styled.div`
  margin-bottom: 5px;
  margin-right: 20px;

  :hover span: {
    visibility: visible;
  }
`;

ChallengesContainer.NoExtract = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 1.6rem;

  @media (max-width: 770px) {
    margin-top: 1rem;
  }

  span {
    color: #808080;
  }
`;

ChallengesContainer.AreadateLabel = styled.div`
  color: #000fff;
`;

ChallengesContainer.Areadate = styled.div`
  text-align: center;
  display: flex;
  flex-direction: column;
  margin-right: 5px;
`;

ChallengesContainer.CategoryMobile = styled.div`
  @media (max-width: 1250px) {
    display: none;
  }
`;

ChallengesContainer.PointsMobile = styled.div`
  @media (max-width: 1010px) {
    display: none;
  }
`;

ChallengesContainer.VerificationMobile = styled.div`
  @media (max-width: 850px) {
    display: none;
  }
`;

ChallengesContainer.ColorMob = styled.div`
  color: ${props => props.result ? '#000fff' :  '#ff8181'};;
  font-weight: 800;
  font-size: 12px;
  padding: 0px 0px 0px 0px;

  p {
    margin-bottom: 1px;
  }
`;

ChallengesContainer.ColorMobile = styled.div`
  @media (max-width: 770px) {
    color: #000fff;
    font-weight: 800;
    font-size: 12px;
    padding: 0px 0px 0px 0px;
  }

  p {
    margin-bottom: 1px;
  }
`;

ChallengesContainer.AreaButtonMobile = styled.div`
  display: flex;
  flex-direction: column;
`;

ChallengesContainer.AreaName = styled.div`
  display: flex;
  flex-direction: column;
  margin-right: 15px;
`;

ChallengesContainer.Input = styled.input`
  display: inline-flex;
  color: #b2b2b2;
  background-color: #fff;
  border: 1px solid #b2b2b2;
  border-radius: 13px;
  padding: 3px 14px;
  font-size: 14px;
  margin: 3px 5px;
  justify-content: center;
  align-items: center;
  &:hover {
    cursor: pointer;
  }
  @media (max-width: 455px) {
    margin-top: 10px;
  }

  ::placeholder {
    color: #b2b2b2;
  }
`;

export default ChallengesContainer;
